<template>
  <div id="app">
    <router-view v-if="isRouterAlive" />
    <cuFooter></cuFooter>
  </div>
</template>
<script>
import cuFooter from "@/components/cuFooter.vue";

export default {
  components: {
    cuFooter,
  },
  provide() {
    return {
      reload: this.reload,
    };
  },
  data() {
    return {
      isRouterAlive: true,
    };
  },
  mounted() {
    window.onresize = () => {
      return (() => {
        this.$store.state.screenWidth = document.body.clientWidth;
      })();
    };
  },
  methods: {
    reload() {
      this.isRouterAlive = false;
      this.$nextTick(function () {
        this.isRouterAlive = true;
      });
    },
  },
};
</script>
<style lang="scss">
html,
body,
#app {
  height: auto;
  font-size: 14px;
  color: #4a4a4a;
}

a {
  display: block;
  text-decoration: none !important;
}
@media (max-width: 768px) {
  html,
  body,
  #app {
    font-size: 12px;
  }
}

* {
  margin: 0px;
  padding: 0px;
  outline: 0 none;
  font-family: Arial, "Microsoft YaHei";
  word-wrap: break-word;
  word-break: break-word;
}

.font-color {
  color: #cfaf75;
  //注释
}

.wrap {
  width: 100%;
  min-height: 100vh;
}

.wrapper {
  min-height: 42rem;
}

h1 {
  font-size: 1.5rem !important;
  color: #666666;
  font-weight: bold !important;
}

h2 {
  font-size: 1.2rem !important;
  color: #666666;
}

.img-wrap {
  width: 100%;
  margin: 2rem auto;
  overflow: hidden;
  transform: rotate(0deg);
  border-radius: 15px;
  img {
    transition: all 2s ease 0s;
  }
  img:hover {
    transform: scale(1.1, 1.1);
    // transition: transform 0.8s cubic-bezier(0.215, 0.61, 0.355, 1), opacity 0.36s cubic-bezier(0.215, 0.61, 0.355, 1);
    // transition: all 0.5s ease 0s;
  }
}
@media (max-width: 768px) {
  .img-wrap {
    border-radius: 10px;
  }
}
ul,
li {
  list-style-type: none;
  margin: 0;
  padding: 0;
}

@media (min-width: 1200px) {
  .wrap {
    .container,
    .container-sm,
    .container-md,
    .container-lg,
    .container-xl {
      max-width: 1200px;
    }
  }
}
</style>
